<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div
		class="flex flex-col items-center justify-center px-10 gap-5"
		*ngIf="status === titlePlusStatus.UNDER_REVIEW"
	>
		<app-icon
			[spin]="loading"
			[icon]="loading ? ICON.LOADING : ICON.GEARS"
			class="text-green text-4xl"
		></app-icon>
		<p class="text-xl font-bold">Under review</p>
		<p>
			Your order has been submitted for underwriting and is awaiting review.
			Please check back later.
		</p>
	</div>
	<div
		class="flex flex-col items-center justify-center px-10 gap-5"
		*ngIf="status === titlePlusStatus.USER_ACTION_REQUIRED"
	>
		<app-icon [icon]="ICON.WARNING" class="text-orange text-4xl"></app-icon>
		<p class="text-xl font-bold">Waiting for information</p>
		<p>Your order requires attention. Please update to continue.</p>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button
			*ngIf="status === titlePlusStatus.UNDER_REVIEW"
			[loading]="loading"
			(click)="checkStatus()"
			[icon]="ICON.REFRESH"
			[testHook]="testHooks.CheckStatusButton"
			>Check status</app-button
		>
		<app-button
			*ngIf="status === titlePlusStatus.USER_ACTION_REQUIRED"
			(click)="openPortal()"
			[icon]="ICON.EXTERNAL"
			[testHook]="testHooks.UpdateOrderButton"
			>Update order</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-title-plus-footer
			[status]="titlePlusStatus.UNDER_REVIEW"
		></app-title-plus-footer>
	</div>
</div>
